import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { createColumnHelper } from '@tanstack/react-table';
import { DateTime } from 'luxon';

import { ManageCell } from './ManageCell';
import type { PassengerAddressRead } from 'src/common/external/bambi-api/bambiApi';
import { removeUnitedStatesFromAddress } from 'src/common/util/removeUnitedStatesFromAddress';

const columnHelper = createColumnHelper<PassengerAddressRead>();

export const columns = [
  columnHelper.accessor('name', {
    id: 'name',
    header: 'Name',
    cell: ({ getValue }) => {
      const name = getValue();
      if (!name) {
        return '-';
      }
      return name;
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('address.location.label', {
    id: 'address.location.label',
    header: 'Address',
    cell: ({ getValue }) => removeUnitedStatesFromAddress(getValue()),
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('is_primary_address', {
    id: 'is_primary_address',
    header: 'Primary',
    cell: ({ getValue }) =>
      getValue() ? (
        <CheckIcon className="h-7 w-7 text-green-600" />
      ) : (
        <XMarkIcon className="h-7 w-7 text-red-600" />
      ),
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('is_billing_address', {
    id: 'is_billing_address',
    header: 'Billing',
    cell: ({ getValue }) =>
      getValue() ? (
        <CheckIcon className="h-7 w-7 text-green-600" />
      ) : (
        <XMarkIcon className="h-7 w-7 text-red-600" />
      ),
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.accessor('last_used_at', {
    id: 'last_used_at',
    header: 'Last Used',
    cell: ({ getValue }) => {
      const date = getValue();
      if (!date) {
        return '-';
      }
      return DateTime.fromISO(date).toLocaleString(DateTime.DATE_SHORT);
    },
    meta: {
      enableHeaderMenu: false,
    },
  }),
  columnHelper.display({
    id: 'actions',
    header: 'Manage',
    cell: ({ row }) => <ManageCell address={row.original} />,
    meta: {
      enableHeaderMenu: false,
    },
  }),
];
